var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _path16, _rect2, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForWhom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 279,
    viewBox: "0 0 1280 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.5C0 11.2452 10.7452 0.5 24 0.5H400C408.837 0.5 416 7.66344 416 16.5V96.5C416 109.755 426.745 120.5 440 120.5H480C488.837 120.5 496 127.663 496 136.5V262.5C496 271.337 488.837 278.5 480 278.5H24C10.7452 278.5 0 267.755 0 254.5V24.5Z",
    fill: "#22E06C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M432 16.5C432 7.66344 439.163 0.5 448 0.5H832C840.837 0.5 848 7.66344 848 16.5V96.5C848 109.755 858.745 120.5 872 120.5H912C920.837 120.5 928 127.663 928 136.5V262.5C928 271.337 920.837 278.5 912 278.5H528C519.163 278.5 512 271.337 512 262.5V128.5C512 115.245 501.255 104.5 488 104.5H448C439.163 104.5 432 97.3366 432 88.5V16.5Z",
    fill: "#22E06C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M864 16.5C864 7.66344 871.163 0.5 880 0.5H1256C1269.25 0.5 1280 11.2452 1280 24.5V108.5V254.5C1280 267.755 1269.25 278.5 1256 278.5H961C952.163 278.5 945 271.337 945 262.5V128.5C945 115.245 934.255 104.5 921 104.5H880C871.163 104.5 864 97.3366 864 88.5V16.5Z",
    fill: "#22E06C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M895.897 45.7053L905.162 73.5001H926.838L936.102 45.7053L941.795 47.6027L931.162 79.5001H900.838L890.205 47.6027L895.897 45.7053Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M916 28.1323L934.243 46.375L930 50.6176L916 36.6176L902 50.6176L897.758 46.375L916 28.1323Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888 45.5L944 45.5V51.5L888 51.5V45.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M897 57.5L935 57.5V63.5L897 63.5V57.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 31.5C40.402 31.5 31 40.902 31 52.5C31 64.098 40.402 73.5 52 73.5C63.598 73.5 73 64.098 73 52.5C73 40.902 63.598 31.5 52 31.5ZM25 52.5C25 37.5883 37.0883 25.5 52 25.5C66.9117 25.5 79 37.5883 79 52.5C79 67.4117 66.9117 79.5 52 79.5C37.0883 79.5 25 67.4117 25 52.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1716 42.7275L52.7724 63.6718L47.8281 60.2726L62.2273 39.3284L67.1716 42.7275Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 57.5L76 57.5L76 63.5L28 63.5L28 57.5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.24 52.343L482.859 64.5991L473.78 57.2223L477.564 52.5656L482.284 56.4009L489.843 48.2603L494.24 52.343Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461 37.5L507 37.5V43.5L461 43.5V37.5Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.022 25.5L507.002 25.5L506.978 61.0745C506.978 61.0752 506.978 61.0759 506.978 61.0766C506.977 63.6422 505.649 65.8838 503.687 67.1923L503.676 67.1992L484.001 80.0855L464.302 67.1996L464.291 67.1923C462.328 65.8834 461 63.641 461 61.0745L461.024 25.5H464.022ZM467.02 31.5L467 61.0745C467 61.0743 467 61.0748 467 61.0745C467 61.5157 467.224 61.9328 467.612 62.1951L483.999 72.9145L500.365 62.1954C500.754 61.933 500.978 61.5161 500.978 61.0745L500.998 31.5L467.02 31.5Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M432 40.5C432 44.9183 428.418 48.5 424 48.5C419.582 48.5 416 44.9183 416 40.5L416 48.5L432 48.5L432 40.5Z",
    fill: "#22E06C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 44.5,
    width: 16,
    height: 28,
    stroke: "#22E06C",
    transform: "rotate(90 432 48.5)",
    fill: "#22E06C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M432 72.5C432 68.0817 428.418 64.5 424 64.5C419.582 64.5 416 68.0817 416 72.5L416 64.5L432 64.5L432 72.5Z",
    fill: "#22E06C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M864 40.5C864 44.9183 860.418 48.5 856 48.5C851.582 48.5 848 44.9183 848 40.5L848 48.5L864 48.5L864 40.5Z",
    fill: "#22E06C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 44.5,
    width: 16,
    height: 28,
    stroke: "#22E06C",
    transform: "rotate(90 864 48.5)",
    fill: "#22E06C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M864 72.5C864 68.0817 860.418 64.5 856 64.5C851.582 64.5 848 68.0817 848 72.5L848 64.5L864 64.5L864 72.5Z",
    fill: "#22E06C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForWhom);
export default __webpack_public_path__ + "static/media/for_whom.c849fdc11a3630239a28409c99d41e32.svg";
export { ForwardRef as ReactComponent };